type SingleCardWrapperProps = {
  children: React.ReactNode;
};

export const SingleCardWrapper = ({ children }: SingleCardWrapperProps) => (
  <div className="pt-8 sm:mx-auto sm:w-full sm:max-w-md">{children}</div>
);
